/**
 * The copyright caption service implementation provides a caption that is supposed to be displayed on a link
 * that provides the full copyright notice. The response is not changed often.
 *
 * This service is supposed to be called once when user has the map displayed for the first time.
 *
 * Parameters need to be passed to the constructor.
 * The method {{#crossLink "Services.services.copyrightsCaption/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The final response from the service is a string containing the caption i.e.,
 *     © 1992 - 2019 TomTom.
 *
 * This text has to be displayed as a copyrights prompt when using TomTom services. The caption should be
 * clickable. A user should be presented with the full copyrights notice when the caption is clicked. For further
 * documentation please check the caption class.
 *
 *
 * @example
 * ```js
 * tt.services.copyrightsCaption({
 *   key: <Your API key>
*  })
 * .go()
 * .then(function(response) {
 *   console.log(response);
 * });
 * ```
 *
 * @class copyrightsCaption
 * @namespace Services.services
 * @module Services
 * @constructor
 * @uses GoMixin
 * @uses KeyMixin
 * @uses ProtocolMixin
 *
 * @param {Object} [options]
 */
import {SERVICE_TYPES} from 'Core/serviceTypes';
import { copyrightsRest } from 'rest/copyrights';
import validators from '../validators';
import serviceFactory from '../serviceFactory';

const fields = {
    key: {
        validators: [validators.key]
    },
    protocol: {
        validators: [validators.oneOfValue(['http', 'https'], 'protocol')]
    },
    sessionId: {
        validators: [validators.string]
    }
};

function handleServiceCall(data) {
    return copyrightsRest.caption(fields, data);
}

export const copyrightsCaption = serviceFactory(fields, SERVICE_TYPES.MAP, 'copyrightsCaption', handleServiceCall);



// WEBPACK FOOTER //
// ./services/services/copyrights/copyrightsCaption.js